import React from 'react'
import styles from './membership-plan-item.scss'
import cn from 'classnames'
import { Radio } from 'antd'
import PropTypes from 'prop-types'
import { getCheckoutInfoByFreeTrail } from 'src/services/stripe_checkout_configs'

const MembershipPlanItem = ({ plan, isSelected, onClick, theme, isFreeTrailUsed }) => {
  const checkoutInfo = getCheckoutInfoByFreeTrail(plan, isFreeTrailUsed)

  return (
    <div
      className={cn(
        styles['plan-item-detail'],
        { [styles['selected-plan']]: isSelected },
        styles[theme]
      )}
      onClick={() => {
        onClick(plan)
      }}>
      <div>
        <Radio checked={isSelected} />
      </div>
      <div className={styles['plan-item-description']}>
        <h1>{checkoutInfo.title}</h1>
        <p>{checkoutInfo.priceDesc}</p>
      </div>
      {plan.isBestValue && (
        <div className={styles['plan-item-best-value-badge']}>Best Value</div>
      )}
    </div>
  )
}

MembershipPlanItem.propTypes = {
  plan: PropTypes.object,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  theme: PropTypes.string,
  isFreeTrailUsed: PropTypes.bool
}

export default MembershipPlanItem
